import { useMutation, useQueryClient } from '@tanstack/react-query'
import { bootstrapQueryKey } from '@/features/bootstrap/api/bootstrap/queries/bootstrap-query'
import { router } from '@/app/router/router'
import { apiClient } from '@/shared/api/client'
import { clearAuthTokens } from '@/shared/lib/auth-tokens'
import { trackLogout } from '@/shared/analytics'
import {
  resolvePreferredLanguage,
  type SupportedLanguage,
} from '@/shared/i18n/supported-languages'

interface LogOutRedirect {
  to: '/$lang' | '/$lang/login'
  lang?: SupportedLanguage
}

interface UseLogOutMutationOptions {
  redirectTo?: LogOutRedirect
}

export function useLogOutMutation(options?: UseLogOutMutationOptions) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationKey: ['logout'],
    mutationFn: () => apiClient.auth.logout(),
    onSuccess: () => {
      trackLogout()
      queryClient.setQueryData(['auth'], null)
      void queryClient.cancelQueries({ queryKey: bootstrapQueryKey })
      queryClient.removeQueries({ queryKey: bootstrapQueryKey })
      clearAuthTokens()

      const redirectTo = options?.redirectTo ?? { to: '/$lang' }
      router.navigate({
        to: redirectTo.to,
        params: { lang: redirectTo.lang ?? resolvePreferredLanguage() },
      })
    },
  })
}
